import { Input, Component, Injector } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'loader',
	template: `
		<div
			[ngClass]="{
				'block-ui-overlay': !isOnRecalculateRates(),
				'block-ui-overlay-recalculate': isOnRecalculateRates()
			}"
		></div>
		<div
			*ngIf="!isOnRecalculateRates()"
			class="block-ui-message-container"
			aria-live="assertive"
			aria-atomic="true"
			ng-class="state.cssClass"
		>
			<div class="block-ui-message" ng-class="$_blockUiMessageClass">
				<div class="sk-circle">
					<div class="sk-circle1 sk-child"></div>
					<div class="sk-circle2 sk-child"></div>
					<div class="sk-circle3 sk-child"></div>
					<div class="sk-circle4 sk-child"></div>
					<div class="sk-circle5 sk-child"></div>
					<div class="sk-circle6 sk-child"></div>
					<div class="sk-circle7 sk-child"></div>
					<div class="sk-circle8 sk-child"></div>
					<div class="sk-circle9 sk-child"></div>
					<div class="sk-circle10 sk-child"></div>
					<div class="sk-circle11 sk-child"></div>
					<div class="sk-circle12 sk-child"></div>
				</div>
				{{ Message }}
			</div>
		</div>
	`,
})
export class LoaderComponent extends BaseComponent {
	@Input() Message: any;
	isSubmissionLoaderFlagOn: boolean = false;

	constructor(injector: Injector) {
		super(injector);
	}

	async ngOnInit() {
		this.layoutService.staticLayout.subscribe((data) => {
			if (data) {
				this.isSubmissionLoaderFlagOn = data.data.globalAttributes['submissionLoaderFlag'];
				var carrierInformation = this.storeService.getValue('CarrierInformation', 'page');
				if (
					data.data.metadata.page.controls &&
					data.data.metadata.page.controls.find((c) => c.controlName == 'CoveragePackages') &&
					data.data.metadata.page.controls
						.find((c) => c.controlName == 'CoveragePackages')
						.options.find((o) => o.carrierName == carrierInformation.name)
				) {
					var coveragesPackagesControl = data.data.metadata.page.controls
						.find((c) => c.controlName == 'CoveragePackages')
						.options.find((o) => o.carrierName == carrierInformation.name);

					this.isSubmissionLoaderFlagOn =
					this.isSubmissionLoaderFlagOn && coveragesPackagesControl.submissionLoaderPopup;
				}
			}
		});
	}

	//returns true if should not! show loader
	isOnRecalculateRates() {
		return this.carrierInformationService.isRecalculating || this.isSubmissionLoaderFlagOn;
	}
}
